import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useProfileFactoryListStyles = makeStyles((theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      flexDirection: 'column'
    },

    container: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gridGap: '23px 31px',
      width: '100%',
      [theme.breakpoints.down('md')]: {
        gridGap: '24px 13px'
      },
      [theme.breakpoints.down('xs')]: {
        gridTemplateColumns: '1fr 1fr',
        gridGap: '15px 7px'
      }
    },

    columnContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 20
    },

    noAds: {
      marginBottom: 23
    },

    modelAmount: {
      height: '20px',
      color: '#757575',
      fontFamily: 'Roboto',
      fontSize: '14px',
      weight: '400',
      lineHeight: '20px',
      letterSpacing: '0em',
      width: 'auto',
      marginTop: 20,
      marginBottom: 40,
      [theme.breakpoints.down(960)]: {
        marginTop: 15,
        marginBottom: 20
      }
    },

    paginationBlock: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 100,
      [theme.breakpoints.down(1024)]: {
        marginTop: 80
      },
      [theme.breakpoints.down(600)]: {
        marginTop: 60
      }
    },

    skeletonCard: {
      width: '100%',
      height: 465,
      [theme.breakpoints.down(1440)]: {
        height: 499
      },
      [theme.breakpoints.down(1280)]: {
        height: 448
      },
      [theme.breakpoints.down(960)]: {
        height: 417
      },
      [theme.breakpoints.down(600)]: {
        height: 349
      }
    },

    skeletonCardColumn: {
      width: '100%',
      height: '128px'
    }
  })
)
